import React from "react";
import { BrowserRouter } from "react-router-dom";
import '../../scss/core.scss';
import '../../scss/skin.scss';

import { history } from '../../helper/history';
import Router from "./Router";

function App() {
    return (
        <BrowserRouter history={history}>
            <Router />
        </BrowserRouter>
    );
}

export default App;
